// extracted by mini-css-extract-plugin
export default {"collapseButton":"CollapseButton_collapseButton__i-55j"};